import genericFields from '../resource/generic-fields'

const createQuery = () => {
  const query = `query Error($url:String!) {
    ${genericFields()}
  }`
  return query
}
export default createQuery
